export var global = typeof window !== 'undefined' ? window : {};